import { DI } from 'aurelia';

enum StructureItemTypeEnum {
  link = 'link',
  section = 'section',
  dropdown = 'dropdown'
}

interface IStructureItem {
  id?: string;
  type: StructureItemTypeEnum;
  displayName?: string;
  displayClosedName?: string;
  icon?: string;
  soon?: boolean;
  itens?: IStructureItem[];
  allowedRoles?: string[];
}

export interface INavBarStructure {
  description: IStructureItem[];
}

class NaviBarStructure implements INavBarStructure {
  public description: IStructureItem[] = [
    {
      type: StructureItemTypeEnum.section,
      // displayName: 'Central',
      allowedRoles: ['admin', 'user', 'user-premium', 'user-freetrial', 'copymagico-admin'],
      itens: [
        {
          id: '455c4f52-8803-43f0-8318-ec83cf621614',
          type: StructureItemTypeEnum.link,
          displayName: 'Meu painel',
          icon: 'meu_painel',
        },
        {
          id: 'c5287143-67e9-48f5-a49d-af64b1a4aac9',
          type: StructureItemTypeEnum.link,
          displayName: 'Clientes e negócios',
          icon: 'clientes_negocios',
        },
      ]
    },

    {
      type: StructureItemTypeEnum.section,
      displayName: 'Inteligência Artificial',
      displayClosedName: 'IA',
      allowedRoles: ['admin', 'user', 'user-premium', 'user-freetrial', 'copymagico-admin'],
      itens: [
        // {
        //   id: '2626615c-18f4-4ea4-98ff-9274f949842c',
        //   type: StructureItemTypeEnum.link,
        //   displayName: 'Seus resultados',
        //   icon: 'resultados',
        // },
        {
          id: '19c62f81-f5eb-4ebf-8547-54dc7b834dde',
          type: StructureItemTypeEnum.link,
          displayName: 'Gerar imagens',
          icon: 'gerar_imagem',
        },
        {
          id: '57225091-f273-4af3-be2a-253d0f46a1c9',
          type: StructureItemTypeEnum.link,
          displayName: 'Criar artigos',
          icon: 'criar_artigos',
        },
        {
          id: 'c73706b5-dbc9-4559-b64e-1897283025da',
          type: StructureItemTypeEnum.link,
          displayName: 'Criar publicações',
          icon: 'criar_publicacao',
        },
        {
          id: '2590c54a-7003-47de-8212-a4f5f3fb2fd2',
          type: StructureItemTypeEnum.link,
          displayName: 'Meus documentos',
          icon: 'documentos',
        },
      ]
    },
    {
      type: StructureItemTypeEnum.section,
      displayName: 'Ferramentas',
      displayClosedName: 'Úteis',
      allowedRoles: ['admin', 'user', 'user-premium', 'user-freetrial', 'copymagico-admin'],
      itens: [
        {
          id: '413604b7-b7ce-4bf8-b423-d4959ec05922',
          type: StructureItemTypeEnum.link,
          displayName: 'Meu calendário',
          icon: 'calendario',
        },
        {
          id: 'fa01a9da-f605-42f3-a475-53db1c0bc0a6',
          type: StructureItemTypeEnum.link,
          displayName: 'Redes sociais',
          icon: 'redes_sociais',
        },
        {
          id: 'b18962b1-30ab-418a-8c47-2cbd4aa17c92',
          type: StructureItemTypeEnum.link,
          displayName: 'Meus produtos',
          icon: 'produtos',
        },
        {
          id: '30786b6c-d274-4ca5-88e1-2698ab8fc7ae',
          type: StructureItemTypeEnum.link,
          displayName: 'Meu site',
          icon: 'site',
        },
        {
          id: '623e0798-9184-4cae-a67a-4fbdaab6c85d',
          type: StructureItemTypeEnum.link,
          displayName: 'Meu blog',
          icon: 'blog',
        },

        {
          id: '577485d9-d9bd-4baf-9261-d0ff848ccc12',
          type: StructureItemTypeEnum.link,
          displayName: 'Minha marca',
          icon: 'marca',
        },
      ]
    },
    {
      type: StructureItemTypeEnum.section,
      displayName: 'Suporte',
      displayClosedName: 'Ajuda',
      allowedRoles: ['admin', 'user', 'user-premium', 'user-freetrial', 'copymagico-admin'],
      itens: [
        {
          id: '19236484-aed9-40e2-8782-2d45c5567fc5',
          type: StructureItemTypeEnum.link,
          displayName: 'Academia da magIA',
          icon: 'academia_magia',
        },
        {
          id: '529597a8-1c0d-47bf-9a78-e41a8c5ff663',
          type: StructureItemTypeEnum.link,
          displayName: 'Ajuda',
          icon: 'ajuda',
        },
      ]
    },
    {
      type: StructureItemTypeEnum.section,
      displayName: 'Administração',
      allowedRoles: ['copymagico-admin'],
      itens: [
        {
          id: 'e10ff062-886f-4165-a547-151fd7920541',
          type: StructureItemTypeEnum.link,
          displayName: 'templateManagement',
          icon: 'mdi mdi-barcode',
        },
        {
          id: 'f054283f-acf8-4ed2-9201-70f54588e5f2',
          type: StructureItemTypeEnum.link,
          displayName: 'components',
          icon: 'mdi mdi-book-open-page-variant',
        },
        {
          id: '2626615c-18f4-4ea4-98ff-9274f949842c',
          type: StructureItemTypeEnum.link,
          displayName: 'projects',
          icon: 'mdi mdi-instagram',
        },
      ]
    }
  ];

}

export const INavBarStructure = DI.createInterface<INavBarStructure>(x => x.singleton(NaviBarStructure));
